import NProgress from "nprogress";
import "nprogress/nprogress.css";
import VueCookie from "vue-cookie";

import router from "./router";
import store from "@/store";
import { checkFrontEndVersion } from "@/api/checkVersion";

NProgress.configure({ showSpinner: false });

// 全局钩子拦截导航
router.beforeEach((to, from, next) => {
    NProgress.start();
    if (to.meta) {
        document.title = to.meta.title;
    }
    let token = VueCookie.get("procuretoken");
    // 检查前端版本
    checkFrontEndVersion()
        .then(() => {
            if (to.name == "login") {
                next();
                NProgress.done();
            } else {
                if (token) {
                    store
                        .dispatch("GetUserInfo")
                        .then(() => {
                            next();
                            NProgress.done();
                        })
                        .catch(() => {
                            store.commit("LOGOUT");
                            next({
                                name: "login",
                                query: { redirect: to.fullPath }
                            });
                            NProgress.done();
                        });
                } else {
                    store.commit("LOGOUT");
                    next({
                        name: "login",
                        query: { redirect: to.fullPath }
                    });
                    NProgress.done();
                }
            }
        })
        .catch(err => {
            console.log(err);
        });
});



// WEBPACK FOOTER //
// ./src/permission.js